// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__14Qyj","fileBtn":"File_fileBtn__2wC7o","closeBtn":"File_closeBtn__3FVXo","fileSelected":"File_fileSelected__33cRQ","disabled":"File_disabled__3dpAt"};